export const DummySidebar = {
  admin: [
    {
      name: "Tổng quan",
      path: "/dashboard",
      componentName: "GeneralFeature",
      icon: "https://apiv2.mobitopup.vn/file/4298df92-a6db-4f32-8808-469406142908.png",
      subMenu: [],
    },
    {
      name: "Lịch sử giao dịch",
      path: "/history",
      componentName: "history",
      icon: "https://apiv2.mobitopup.vn/file/e218a50a-d38c-46c1-b65e-7e1b2d089917.png",
      subMenu: [
        {
          name: "Gói cước",
          path: "/history/transaction",
          componentName: "TransactionFeature",
          icon: "https://apiv2.mobitopup.vn/file/1d99260e-7458-44c2-82e8-c2133b197054.png",
          subMenu: [],
        },
        {
          name: "Đơn hàng mua sim",
          path: "/history/order-list",
          componentName: "SimOrdersForPartnersFeature",
          icon: "https://apiv2.mobitopup.vn/file/845231d3-4964-4cb3-8850-a1d04a79008f.png",
          subMenu: [],
        },
        {
          name: "Đăng ký sim du lịch",
          path: "/history/travel-sim-list",
          componentName: "TravelSimListFeature",
          icon: "https://apiv2.mobitopup.vn/file/6fe0cbfb-177b-440f-a9c8-374818448d04.png",
          subMenu: [],
        },
        {
          name: "Số dư",
          path: "/history/balance",
          componentName: "BalanceHistoryFeature",
          icon: "https://apiv2.mobitopup.vn/file/6fe0cbfb-177b-440f-a9c8-374818448d04.png",
          subMenu: [],
        },
      ],
    },
    {
      name: "Quản lý",
      path: "/data",
      componentName: "data",
      icon: "https://apiv2.mobitopup.vn/file/179d2d38-3435-48fe-8650-8c08fb8ce150.png",
      subMenu: [
        {
          name: "Gói cước Data",
          path: "/data/data-packages",
          componentName: "TopupManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/1d99260e-7458-44c2-82e8-c2133b197054.png",
          subMenu: [],
        },
        {
          name: "Gói cước Roaming",
          path: "/data/roaming-packages",
          componentName: "RoamingManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/8eac226f-1f49-4120-b005-7a8b1b721262.png",
          subMenu: [],
        },
        {
          name: "Bài viết",
          path: "/data/content-management",
          componentName: "ContentManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/64a6449e-2e26-473e-971d-3eafccabe30a.png",
          subMenu: [],
        },
        {
          name: "Tỉnh thành",
          path: "/data/address-management",
          componentName: "AddressManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/34a6628a-e116-4232-a582-f367bbd6122e.png",
          subMenu: [],
        },
        {
          name: "Đối tác",
          path: "/data/partner-management",
          componentName: "PartnerManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/34a6628a-e116-4232-a582-f367bbd6122e.png",
          subMenu: [],
        },
      ],
    },
    {
      name: "Cấu hình hệ thống",
      path: "/management",
      componentName: "management",
      icon: "https://apiv2.mobitopup.vn/file/79578057-8537-4053-a7ae-5749941a8472.png",
      subMenu: [
        {
          name: "Người dùng",
          path: "/management/user-management",
          componentName: "UserManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/19d631c2-39c6-4cc9-a4e5-69aed5d893b9.png",
          subMenu: [],
        },
        {
          name: "Quốc gia",
          path: "/management/country",
          componentName: "CountryManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/8eac226f-1f49-4120-b005-7a8b1b721262.png",
          subMenu: [],
        },
        {
          name: "Platform",
          path: "/management/path-config",
          componentName: "PathConfigMangementFeature",
          icon: "https://apiv2.mobitopup.vn/file/0f68cb4f-0fc9-4399-b93f-742e4c338aba.png",
          subMenu: [],
        },
        {
          name: "CDN",
          path: "/management/file",
          componentName: "FileManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/cdf1cbac-6c8e-418d-b00b-9a67accf0a99.png",
          subMenu: [],
        },
      ],
    },
  ],
  user: [
    {
      name: "Tổng quan",
      path: "/dashboard",
      componentName: "GeneralFeature",
      icon: "https://apiv2.mobitopup.vn/file/e218a50a-d38c-46c1-b65e-7e1b2d089917.png",
      subMenu: [],
    },
    {
      name: "Lịch sử giao dịch",
      path: "/history",
      componentName: "history",
      icon: "https://apiv2.mobitopup.vn/file/e218a50a-d38c-46c1-b65e-7e1b2d089917.png",
      subMenu: [
        {
          name: "Gói cước",
          path: "/history/transaction",
          componentName: "TransactionFeature",
          icon: "https://apiv2.mobitopup.vn/file/1d99260e-7458-44c2-82e8-c2133b197054.png",
          subMenu: [],
        },
      ],
    },
  ],
};
